/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {homeMock} from './mock'

export const get_activity_info = createAsyncThunk(
  'BigRVote2026V2/get_activity_info',
  async (p: any, store: any) => {
    // return homeMock
    const resp = await http.post(
      '/live/commonactivity/get_activity_info',
      {
        ...p,
      },
      {
        store: window.store,
        xcErrorToast: true,
      }
    )
    return resp.data?.data
  }
)

export const voteInfo = createAsyncThunk(
  'BigRVote2026V2/rich_vote_race_homepage',
  async (p: any, store: any) => {
    // return homeMock
    const resp = await http.post(
      '/live/activity/rich_vote_race_v2_homepage',
      {
        ...p,
      },
      {
        store: window.store,
        xcErrorToast: true,
      }
    )
    return resp.data?.data
  }
)

export const voteRank = createAsyncThunk(
  'BigRVote2026V2/rich_vote_race_rank',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/rich_vote_race_v2_rank',
      {
        ...p,
      },
      {
        store: window.store,
        xcErrorToast: true,
      }
    )
    return resp.data?.data
  }
)

const initialState = {
  homepage: null,
  activityInfo: null,
}

export const BigRVote2026V2Slice = createSlice({
  name: 'BigRVote2026V2',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(voteInfo.fulfilled, (state, action) => {
      state.homepage = action.payload
    })
    builder.addCase(get_activity_info.fulfilled, (state, action) => {
      state.activityInfo = action.payload
    })
  },
})

export default BigRVote2026V2Slice.reducer
export const BigRVote2026V2SliceActions = BigRVote2026V2Slice.actions

export const useReducerState = () => {
  const data = useSelector((state) => {
    return state.BigRVote2026V2
  })
  return data
}
